export enum CivilityEnum {
	MADAME = 'Mme',
	MONSIEUR = 'M'
}